import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../api";
import BackButton from "../components/BackButton";
import Breadcrumbs from "../components/Breadcrumbs";
import ApiImage from "../components/ApiImage";
import Icon from "../lib/icon";
import Button from "../components/Button";
import BottomSheet from "../components/BottomSheet/BottomSheet";
import { useToast } from "../contexts/ToastContext";

import "./scss/manager-market.scss";
import ManagerMarketProductsBlock from "../components/ManagerMarketProductsBlock";

export default function ManagerMarketPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { showToast, showConfirm } = useToast();

  const [market, setMarket] = useState(null);
  const [blockOpen, setBlockOpen] = useState(false);
  const [blockReason, setBlockReason] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    load();
  }, [id]);

  async function load() {
    const { data } = await api.get(`/api/manager/markets/${id}`);
    setMarket(data);
  }

  async function handleApprove() {
    showConfirm({
      message: "Разблокировать магазин?",
      confirmText: "Разблокировать",
      onConfirm: async () => {
        await api.post(`/api/manager/markets/${id}/approve`);
        showToast("Магазин разблокирован", "info");
        load();
      }
    });
  }

  async function handleBlockSubmit() {
    if (!blockReason.trim()) return;

    try {
      setLoading(true);

      await api.post(`/api/manager/markets/${id}/block`, {
        reason: blockReason
      });

      showToast("Магазин заблокирован", "info");
      setBlockOpen(false);
      setBlockReason("");
      load();
    } catch {
      showToast("Ошибка блокировки");
    } finally {
      setLoading(false);
    }
  }

  if (!market) return null;

  return (
    <div className="manager-market">

      {/* HEADER */}
      <div className="manager-market__header">
        <BackButton />

        <Breadcrumbs
          items={[
            { label: "Главная", path: "/manager/dashboard" },
            { label: "Магазины", path: "/manager/markets" },
            { label: market.name }
          ]}
        />
      </div>

      {/* HERO */}
      <div className="manager-market__hero">
        <div className="manager-market__hero-top">

          <div className="manager-market__hero-left">
            <div className="manager-market__avatar-circle">
              {market.avatar
                ? <ApiImage src={market.avatar} />
                : <span>{market.name[0]}</span>}
            </div>

            <div className="manager-market__hero-info">
              <div className="manager-market__name-row">
                <div className="manager-market__title">
                  {market.name}
                </div>

                <div className="manager-market__status active">
                  Активен
                </div>
              </div>

              <div className="manager-market__rating">
                <Icon name="star-filled" width={14} height={14} color="#FE9402" />
                <span>{market.rating ?? 0}</span>
                <span className="count">
                  {market.ratingCount ?? 0} оценок
                </span>
              </div>
            </div>
          </div>

          <div className="manager-market__edit-btn" onClick={() => {navigate(`/manager/market/${market.id}`)}}>
            <Icon name="edit" width={18} height={18} />
          </div>

        </div>

        <div className="manager-market__phone-label">
          Номер телефона владельца
        </div>

        <div className="manager-market__phone">
          {market.phone}
        </div>

        <div className="manager-market__delivery">
          🚚 45–55 мин с 09:00 до 23:00
        </div>

        <div className="manager-market__description">
          {market.description}
        </div>
      </div>

      {/* BLOCK REASON */}
      {market.status === "blocked" && market.moderatorComment && (
        <div className="manager-market__card danger">
          <div className="title">Причина блокировки</div>
          <div className="text">{market.moderatorComment}</div>
        </div>
      )}

      {/* ACTIONS */}
      <div className="manager-market__actions">
        {market.status !== "approved" && (
          <Button className="btn-primary" onClick={handleApprove}>
            Разблокировать
          </Button>
        )}

        {market.status !== "blocked" && (
          <Button className="btn-danger" onClick={() => setBlockOpen(true)}>
            Заблокировать магазин
          </Button>
        )}
      </div>

      {/* DESCRIPTION */}
      <div className="manager-market__card">
        <div className="title">Описание</div>
        <div className="text">
          {market.description || "Описание отсутствует"}
        </div>
      </div>

      {/* SELLER */}
      <div className="manager-market__card">
        <div className="title">Продавец</div>
        <div className="manager-market__seller">
          <div>Телефон: {market.sellerPhone}</div>
          <div>Email: {market.sellerEmail}</div>
        </div>
      </div>

      {/* PRODUCTS MOCK */}
      <ManagerMarketProductsBlock marketId={market.id} />

      {/* BLOCK SHEET */}
      <BottomSheet
        open={blockOpen}
        onClose={() => setBlockOpen(false)}
        header="Причина блокировки"
        closeButtomShow={true}
      >
        <textarea
          className="manager-market__textarea"
          placeholder="Опишите причину"
          value={blockReason}
          onChange={(e) => setBlockReason(e.target.value)}
        />

        <Button
          className="btn-danger"
          onClick={handleBlockSubmit}
          disabled={!blockReason.trim()}
          load={loading}
        >
          Заблокировать
        </Button>
      </BottomSheet>

    </div>
  );
}
